module.exports = __webpack_public_path__ + "ClientApp/content/Yvonne and Ranger.jpg";